import { cn } from "@/lib/utils";

export type AgeRating = "p3" | "p7" | "p12" | "p16" | "p18";

const config: Record<AgeRating, { label: string; color: string }> = {
  p3: { label: "3+", color: "bg-success-solid text-success-on-solid" },
  p7: { label: "7+", color: "bg-success-solid text-success-on-solid" },
  p12: { label: "12+", color: "bg-warning-solid text-warning-on-solid" },
  p16: { label: "16+", color: "bg-warning-solid text-warning-on-solid" },
  p18: { label: "18+", color: "bg-danger-solid text-danger-on-solid" },
};

export default function AgeRatingBadge({ value }: { value: AgeRating }) {
  const { label, color } = config[value];
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded px-1.5 py-0.5 text-xs font-bold leading-none",
        color,
      )}
    >
      {label}
    </span>
  );
}
